import React from "react";
import CustomAccordian from "./Audit/CustomAccordian";
import { useMainStore } from "@/stores";
import { useParams } from "react-router-dom";
import { useWhitespacingAccountActionPlan } from "@/features/accounts/hooks/useAccounts";
import Loader from "@/shared/components/ui/Loaders/Loader";

const WhitespaceAudit = () => {
  const { user } = useMainStore();
  const { companyDomain } = useParams();
  const { data: whitespacingAccountActionPlan, isLoading, isError } =
    useWhitespacingAccountActionPlan({
      userId: user?.id,
      companyName: companyDomain,
      enabled: !!user?.id && !!companyDomain,
    });

  return (
    <div className="mt-1 flex flex-col w-full h-[calc(100vh-280px)] gap-6 font-sans overflow-auto">
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <Loader text="Loading whitespace audit..." />
        </div>
      ) : isError || !whitespacingAccountActionPlan?.audits?.length ? (
        <div className="flex flex-col items-center justify-center gap-1.5 w-full h-full text-center px-4">
          <h4 className="text-[0.85rem] font-semibold text-gray-900 dark:text-gray-100">
            {isError ? "Couldn't load the whitespace audit" : "No whitespace opportunities found"}
          </h4>
          <p className="max-w-md text-[0.75rem] leading-5 text-gray-500 dark:text-gray-400">
            {isError
              ? "Something went wrong while analysing this account. Please try again in a moment."
              : "No public, dated evidence matched your services for this account yet. Check that your company services are up to date."}
          </p>
        </div>
      ) : (
        <CustomAccordian
          auditsData={whitespacingAccountActionPlan?.audits}
          userId={user?.id}
          companyName={companyDomain}
        />
      )}
    </div>
  );
};

export default WhitespaceAudit;
